import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const StarChart1Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'star',
    items: ['star-rating'],
  },
];
